import JobService from '@/services/JobService.js'

export const namespaced = true

export const state = {
	jobs: [],
	job: {},
	limit: 5,
	activeTab: 'new',
	jobParams: {},
	isShowMyJob: false,
	sortBy: 'rundate',
	prevScrollY: 0,
	isDupScrollY: false,
	report: '',
	isLoading: false
}

export const mutations = {
	SET_JOBS(state, { jobs }) {
		if (!state.isDupScrollY) {
			state.jobs = state.jobs.concat(jobs)
		}
	},
	SET_JOB_PARAMS(state, { jobParams }) {
		state.jobParams = jobParams
	},
	CLEAR_JOBS(state) {
		state.jobs = []
	},
	SET_JOB(state, { job }) {
		state.job = job
	},
	CLEAR_JOB(state) {
		state.job = {}
	},
	ACCPET_JOB(state, { job }) {
		const job_id = job.job_id
		const preJobs = state.jobs
		const newJobs = preJobs.map(preJob => {
			if (preJob.job_id === job_id) {
				return job
			} else {
				return preJob
			}
		})
		state.job = job
		state.jobs = newJobs
	},
	UPDATE_JOB(state, { job }) {
		state.job = job
	},
	SET_ACTIVE_TAB(state, { activeTab }) {
		state.activeTab = activeTab
	},
	SET_IS_SHOW_MY_JOB(state, { isShowMyJob }) {
		state.isShowMyJob = isShowMyJob
	},
	SET_SORT_BY(state, { sortBy }) {
		state.sortBy = sortBy
	},
	SET_PREV_SCROLL_Y(state, { scrollY }) {
		state.prevScrollY = scrollY
	},
	SET_DUP_SCROLL_Y_TRUE(state) {
		state.isDupScrollY = true
	},
	SET_DUP_SCROLL_Y_FALSE(state) {
		state.isDupScrollY = false
	},
	SET_REPORT(state, { report }) {
		state.report = report
	},
	SET_LOADING(state) {
		state.isLoading = true
	},
	SET_NOT_LOADING(state) {
		state.isLoading = false
	}
}

export const actions = {
	async fetchJobs(
		{ commit, dispatch },
		{ job_status, query_type, pageSize, sortBy, exclusiveStartKey }
	) {
		try {
			commit('SET_LOADING')
			const response = await JobService.getJobs(
				job_status,
				query_type,
				pageSize,
				sortBy,
				exclusiveStartKey
			)
			const jobs = response.data.items
			commit('SET_JOBS', { jobs })
			commit('SET_NOT_LOADING')
			return jobs
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	async searchJobsByClientEmail(
		{ commit, dispatch },
		{
			client_email,
			job_status,
			query_type,
			pageSize,
			sortBy,
			exclusiveStartKey
		}
	) {
		try {
			const response = await JobService.searchJobsByClientEmail(
				client_email,
				job_status,
				query_type,
				pageSize,
				sortBy,
				exclusiveStartKey
			)

			const jobs = response.data.items
			console.log(response)
			commit('SET_JOBS', { jobs })
			return jobs
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			console.log(notification)
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	async searchJobsByBookingNumber(
		{ commit, dispatch },
		{
			booking_number,
			job_status,
			query_type,
			pageSize,
			sortBy,
			exclusiveStartKey
		}
	) {
		try {
			const response = await JobService.searchJobsByBookingNumber(
				booking_number,
				job_status,
				query_type,
				pageSize,
				sortBy,
				exclusiveStartKey
			)

			const jobs = response.data.items
			console.log(response)
			commit('SET_JOBS', { jobs })
			return jobs
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			console.log(notification)
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	async searchJobsByJobTitle(
		{ commit, dispatch },
		{
			job_title,
			job_status,
			query_type,
			pageSize,
			sortBy,
			exclusiveStartKey
		}
	) {
		try {
			const response = await JobService.searchJobsByJobTitle(
				job_title,
				job_status,
				query_type,
				pageSize,
				sortBy,
				exclusiveStartKey
			)

			const jobs = response.data.items
			console.log(response)
			commit('SET_JOBS', { jobs })
			return jobs
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			console.log(notification)
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	async getReport({ commit, dispatch }, { beginDate, endDate }) {
		try {
			const response = await JobService.getReport(beginDate, endDate)

			const report = response.data.report
			console.log(report)
			commit('SET_REPORT', { report })
			return report
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			console.log(notification)
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	async createJob({ dispatch }, { job }) {
		try {
			await JobService.createJob(job)
			const notification = {
				type: 'success',
				message: `Congratulation, Job is created.`
			}
			dispatch('notification/add', notification, { root: true })
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},
	async acceptJob(
		{ commit, dispatch },
		{ job_id, staff_name, staff_email, job_status }
	) {
		try {
			const response = await JobService.acceptJob(
				job_id,
				staff_name,
				staff_email,
				job_status
			)
			const job = response.data.data.Attributes
			console.log(job)
			commit('ACCPET_JOB', { job })
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	async completeJob({ commit, dispatch }, { job_id }) {
		try {
			const response = await JobService.completeJob(job_id)
			const job = response.data
			commit('SET_JOB', { job })
			const notification = {
				type: 'success',
				message: `Job is completed.`
			}
			dispatch('notification/add', notification, { root: true })
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	async approveJob({ commit, dispatch }, { job_id }) {
		try {
			const response = await JobService.approveJob(job_id)
			const job = response.data
			commit('SET_JOB', { job })
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	async addUnreadStaffPost({ commit }, { job_id }) {
		try {
			await JobService.addUnreadStaffPost(job_id)
		} catch (e) {
			console.log(e)
		}
	},

	async addUnreadClientPost({ commit }, { job_id }) {
		try {
			await JobService.addUnreadClientPost(job_id)
		} catch (e) {
			console.log(e)
		}
	},

	async clearUnreadClientPost({ commit }, { job_id }) {
		try {
			await JobService.clearUnreadClientPost(job_id)
		} catch (e) {
			console.log(e)
		}
	},

	async clearUnreadStaffPost({ commit }, { job_id }) {
		try {
			await JobService.clearUnreadStaffPost(job_id)
		} catch (e) {
			console.log(e)
		}
	},

	async getJob({ commit, dispatch }, { job_id }) {
		try {
			const response = await JobService.getJob(job_id)
			const job = response.data
			console.log(response)
			commit('SET_JOB', { job })
			return job
		} catch (e) {
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	async getJobsParams({ commit, dispatch }, { bookingNumber }) {
		try {
			const response = await JobService.getJobsParams(bookingNumber)
			const jobParams = response.data
			if (jobParams) {
				const notification = {
					type: 'success',
					message: `Congratulation, Job is fetched.`
				}
				dispatch('notification/add', notification, { root: true })
			}
			commit('SET_JOB_PARAMS', { jobParams })
			return jobParams
		} catch (e) {
			const notification = {
				type: 'error',
				message: `This number is not yet allocated. Please enter your job details manually.`
			}
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},

	setActiveTab({ commit }, { activeTab }) {
		commit('SET_ACTIVE_TAB', { activeTab })
	},
	clearJobs({ commit }) {
		commit('CLEAR_JOBS')
	},
	setIsShowMyJob({ commit }, { isShowMyJob }) {
		commit('SET_IS_SHOW_MY_JOB', { isShowMyJob })
	},
	setSortBy({ commit }, { sortBy }) {
		commit('SET_SORT_BY', { sortBy })
	},
	setPrevScrollY({ state, commit }, { scrollY }) {
		const prevScrollY = state.prevScrollY
		if (scrollY === prevScrollY) {
			commit('SET_DUP_SCROLL_Y_TRUE')
		} else {
			commit('SET_DUP_SCROLL_Y_FALSE')
		}
		commit('SET_PREV_SCROLL_Y', { scrollY })
	}
}
